import { useEffect } from "react";

/*
 * Cliengo (chatbot + CRM) — canal único de chat, cargado en diferido
 * (después del evento load) para no afectar el rendimiento. Se monta en
 * todas las páginas (Home, Landing y Privacidad). El guion del bot se
 * configura en el panel de Cliengo; para la landing de pauta, ese guion
 * debe mantenerse libre de términos de adicciones/rehabilitación.
 */
const CLIENGO_SRC =
  "https://s.cliengo.com/weboptimizer/62df5bd967448c002a058aa6/62df5bdb67448c002a058aaa.js?platform=onboarding_modular";

export default function ChatPlaceholder() {
  useEffect(() => {
    if (document.getElementById("cliengo-widget-script")) return;
    const load = () => {
      if (document.getElementById("cliengo-widget-script")) return;
      const s = document.createElement("script");
      s.id = "cliengo-widget-script";
      s.type = "text/javascript";
      s.async = true;
      s.src = CLIENGO_SRC;
      const first = document.getElementsByTagName("script")[0];
      first.parentNode.insertBefore(s, first);
    };
    if (document.readyState === "complete") setTimeout(load, 1200);
    else
      window.addEventListener("load", () => setTimeout(load, 1200), {
        once: true,
      });
  }, []);

  return null;
}
